<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Contratos - Mesa de aprovação</h5>
        
      </div>
    </div>

    <list-merchant-contracts class="mb-4" />
  </div>
</template>
<script>
import moment from "moment";
import ListMerchantContracts from "./lista";


export default {
  components: {
    ListMerchantContracts
    
  },
  data: function() {
    return {
        dateFormat: 'DD/MM/YYYY',
      monthFormat: 'YYYY/MM',
      dateFormatList: ['DD/MM/YYYY', 'DD/MM/YY'],
    };
  },
  methods: {
      moment,
  },
  mounted() {}
};
</script>
